import { useEffect, useRef, useState } from "react";
import { DateRange } from "react-date-range";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";

import styled from "styled-components";

import format from "date-fns/format";
import { addDays } from "date-fns";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const BodyWrapper = styled.div`
  .calendarContainer {
    position: absolute;
    top: -100px;
    z-index: 100;

    .rdrDateDisplayWrapper {
      background-color: white;
    }

    .footerControls {
      background-color: white;
      padding: 10px 10px;
      display: flex;
      gap: 10px;

      .applyButton {
        cursor: pointer;
        width: 50%;
        border: none;
        background-color: #004576;
        padding: 10px 10px;
        color: white;
      }

      .cancelButton {
        cursor: pointer;
        width: 50%;
        border: none;
        background-color: white;
        padding: 10px 10px;
        color: black;
        border: 1px solid #004576;
      }
    }
  }

  .calendarWrap {
    .inputBoxContainer {
      border-bottom: 1px solid #8b8b8b;
      padding: 10px 10px;
      background-color: #f0f1f1;
      cursor: pointer;
      .inputBox {
        background-color: #f0f1f1;
        cursor: pointer;
      }
    }
    .dateFormat {
      font-size: 10px;
      width: 100%;
      margin-top: 2px;
    }
  }
`;

const DateRangeComp = ({ selectedDateRange, onApplyClick }) => {
  const defaultDateRange = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];

  const [range, setRange] = useState([
    {
      startDate: selectedDateRange[0],
      endDate: selectedDateRange[1],
      key: "selection",
    },
  ]);

  const [previousRange, setPreviousRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  useEffect(() => {
    setRange([
      {
        startDate: selectedDateRange[0],
        endDate: selectedDateRange[1],
        key: "selection",
      },
    ]);
  }, [selectedDateRange]);

  const [open, setOpen] = useState(false);

  // get the target element to toggle
  const refOne = useRef(null);

  useEffect(() => {
    // event listeners
    document.addEventListener("keydown", hideOnEscape, true);
    // document.addEventListener("click", hideOnClickOutside, true);
  }, []);

  // hide dropdown on ESC press
  const hideOnEscape = (e) => {
    if (e.key === "Escape") {
      setOpen(false);
    }
  };

  // Hide on outside click
  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setOpen(false);
    }
  };

  const getDateValue = () => {
    if (range[0]?.startDate === null) {
      return null;
    } else
      return `${format(range[0].startDate, "MM/dd/yyyy")} - ${format(
        range[0].endDate,
        "MM/dd/yyyy"
      )}`;
  };

  const handleCancelClick = () => {
    setRange(previousRange);
    setOpen(false);
  };

  const handleDateInputBoxClick = () => {
    setPreviousRange(range);
    if (range[0].startDate == null)
      setRange([
        {
          startDate: new Date(),
          endDate: addDays(new Date(), 7),
          key: "selection",
        },
      ]);
    else setRange(range);
    setOpen(true);
  };

  return (
    <BodyWrapper>
      <div className="calendarWrap">
        <div className="inputBoxContainer" onClick={handleDateInputBoxClick}>
          <input
            value={getDateValue()}
            readOnly
            key={range[0].startDate}
            placeholder="Enter a date range"
            className="inputBox"
          />

          <FontAwesomeIcon icon={faCalendar} style={{ color: "#8b8b8b" }} />
        </div>
        <div className="dateFormat">MM/DD/YYYY - MM/DD/YYYY</div>

        <div ref={refOne}>
          {open && (
            <div className="calendarContainer">
              <DateRange
                onChange={(item) => setRange([item.selection])}
                editableDateInputs={true}
                moveRangeOnFirstSelection={false}
                ranges={range[0].startDate == null ? defaultDateRange : range}
                months={1}
                direction="horizontal"
                className="calendarElement"
              />
              <div className="footerControls">
                <button
                  className="applyButton"
                  onClick={() => {
                    setOpen(false);
                    onApplyClick(range);
                  }}
                >
                  Apply
                </button>
                <button className="cancelButton" onClick={handleCancelClick}>
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </BodyWrapper>
  );
};

export default DateRangeComp;
